import React, { useEffect, useMemo } from 'react';
import { Menu, Typography, Button } from 'antd';
import { PlusOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { fetchRecentWorkspaces, fetchWorkspaceByType } from '../../features/organization/organizationSlice';
import { useDispatch, useSelector } from 'react-redux';
import WorkspaceList from './WorkspaceList';

const { Text } = Typography;

/**
 * Renders the workspace section of the left sidebar
 */
const WorkspaceMenu = ({
  activeWorkspace,
  collapseLeftBar,
  isCollaspse,
  setIsCollaspse,
  setOpenWorkspaceCreateModal,
  popoverMenuContent,
}) => {
  const dispatch = useDispatch();

  const organizationId = useSelector((state) => state.organization?.userOrganization?.id);
  const typeData = useSelector((state) => state.organization?.newWorkspaceList?.['PRIVATE']) || [];
  const workspaceLoading = useSelector((state) => state.organization?.loading?.fetchWorkspaceByType);
  const recentWorkspacesLoading = useSelector((state) => state.organization?.loading?.recentWorkspaces);
  const recentWorkspaces = useSelector((state) => state.organization?.recentWorkspaces);
  const starredWorkspace = useSelector((state) => state.organization?.starredWorkspace?.data);
  const starredWorkspaceLoading = useSelector((state) => state.organization?.loading?.starredWorkspace);

  useEffect(() => {
    if (organizationId) {
      dispatch(
        fetchWorkspaceByType({
          type: 'PRIVATE',
          skip: 0,
          limit: 4,
          organizationId,
        })
      );
    }
  }, [organizationId]);

  useEffect(() => {
    dispatch(
      fetchRecentWorkspaces({
        params: { limit: 4 },
      })
    );
  }, []);

  // Create workspace menu items for the header
  const workspaceMenuItems = useMemo(
    () => [
      {
        key: 1,
        label: (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Text
              ellipsis={{ tooltip: true }}
              style={{
                flex: 1,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: 'rgba(0, 0, 0, 0.65)',
              }}
            >
              Workspaces
            </Text>
            <div style={{ display: 'flex' }}>
              <Button
                type="text"
                size="small"
                className="action-btn"
                style={{ marginLeft: 4 }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setOpenWorkspaceCreateModal(true);
                }}
              >
                <PlusOutlined />
              </Button>
              <Button
                type="text"
                size="small"
                className="action-btn"
                style={{ marginLeft: 4 }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsCollaspse((prev) => !prev);
                }}
              >
                {isCollaspse ? <RightOutlined /> : <LeftOutlined />}
              </Button>
            </div>
          </div>
        ),
      },
    ],
    [setOpenWorkspaceCreateModal, isCollaspse, setIsCollaspse]
  );

  if (!activeWorkspace) return null;

  return (
    <div className="workspace-section">
      {!collapseLeftBar && (
        <div className="workspace-header">
          <Menu
            mode="inline"
            items={workspaceMenuItems}
            className={`workspace-menu ${collapseLeftBar ? 'workspace-menu-collapsed' : ''}`}
            style={{ border: 'none', paddingLeft: collapseLeftBar ? '8px' : '' }}
          />
        </div>
      )}

      <div className="leftbar-workspaceList">
        {(recentWorkspacesLoading || recentWorkspaces) && (
          <WorkspaceList
            title="Recent"
            workspaceData={recentWorkspaces?.workspaces}
            loading={recentWorkspacesLoading}
            popoverMenuContent={popoverMenuContent}
            collapseLeftBar={collapseLeftBar}
          />
        )}

        {(starredWorkspaceLoading || starredWorkspace) && (
          <WorkspaceList
            title="Starred workspaces"
            workspaceData={starredWorkspace}
            loading={starredWorkspaceLoading}
            popoverMenuContent={popoverMenuContent}
            collapseLeftBar={collapseLeftBar}
          />
        )}

        {(workspaceLoading || typeData) && (
          <WorkspaceList
            title="Private"
            workspaceData={typeData}
            loading={workspaceLoading}
            popoverMenuContent={popoverMenuContent}
            collapseLeftBar={collapseLeftBar}
          />
        )}
      </div>
    </div>
  );
};

export default WorkspaceMenu;
